import { TCommonVipBadgeType } from '~/api/converters/global/common/VipDiscountBadge/index.type'
import { DomesticOrderCancelPolicyPropertyBody } from '~/api/routes/domestic/order/controller/type'

export const CancelPolicyType = {
  /** 예외규정에 의한 무료취소 */
  EXCEPTIONAL_FREE: 'EXCEPTIONAL_FREE',
  /** 확정 금액 (현재 장바구니에서는 사용되지 않지만 추후 확장성을 고려하여 필드 유지) */
  FIXED: 'FIXED',
  /** 무료취소 */
  FREE: 'FREE',
  /** 비율 */
  RATIO: 'RATIO',
  /** 전액 취소수수료 */
  TOTAL: 'TOTAL',
} as const

export type TCancelPolicyType = keyof typeof CancelPolicyType

export interface ICancelPolicy {
  type: TCancelPolicyType
  endAt?: string
  weight?: number
}

export const PickupType = {
  /** 마트 픽업 */
  MART_PICKUP: 'MART_PICKUP',
  /** 픽업 */
  PICKUP: 'PICKUP',
  /** 미제공 */
  NOT_PROVIDED: 'NOT_PROVIDED',
} as const

export type TPickupType = keyof typeof PickupType

export type PickupInfoBottomSheetProps = {
  propertyName: string
  address: string
  phone: string
  pickupType?: TPickupType
  pickupDescription: string
}

export type SelectVisitTypeProps = {
  typeIndex: number
  visitTypeName: string
  visitTypes: {
    value: string
    label: string
    testId?: string
    disabled?: boolean
  }[]
}

export type ParkingPickupInfoProps = {
  typeIndex: number
  isAvailableParking: boolean
  parkingUnavailableReason: string
  isAvailablePickup: boolean
  pickUpType?: TPickupType
  pickupInfoBottomSheetProps?: PickupInfoBottomSheetProps
}

export type DomesticOrderPropertyItemsProps = {
  badges?: string[]
  propertyName: string
  roomTypeName: string
  hasRatePlanOptionInfo: boolean
  ratePlanTitle: string
  // @deprecated ratePlanBenefits -> rateplanBenefitList
  ratePlanBenefits: string
  ratePlanBenefitList: string[]
  vipBadgeType: TCommonVipBadgeType | ''
  timeOptions: { title: string; date: string; time: string }[]
  isDayUse: boolean
  capacityText: string
  priceText: string
  cancelPolicy?: ICancelPolicy | null
  refreshCancelPolicyParams: DomesticOrderCancelPolicyPropertyBody
  isPendingReservation: boolean
  useTypeText: string
  isExceptionalCancelPolicy: boolean
  isCancelFree: boolean
  selectVisitTypeProps?: SelectVisitTypeProps
  parkingPickupInfo: ParkingPickupInfoProps
}
